import { useEffect, useMemo, useState } from "react";
import { useMe } from "@/api/services/main/auth";
import { USER_TYPE } from "@/types/enum";

const TUTORIAL_HIDDEN_KEY = "irohana_study_tutorial_hidden";

const getTutorialHiddenKey = (userId: number) => `${TUTORIAL_HIDDEN_KEY}_${userId}`;

export const useTutorialVisibility = () => {
  const { data: meResult } = useMe();

  // API will return this field to hide tutorial for specific users, but currently there is no such case, so we set it to false.
  const isTutorialHidden = false;
  const userId = meResult?.data?.id;
  const userType = meResult?.data?.type;
  const isRsoUser = userType === USER_TYPE.RSO_USER;
  const isCompanyUser = userType === USER_TYPE.COMPANY_USER;
  const isCompanyUserCreatedByRso = isCompanyUser && !!meResult?.data?.rsoId;

  const [isLocallyHidden, setIsLocallyHidden] = useState(false);

  useEffect(() => {
    if (userId) {
      const storedValue = localStorage.getItem(getTutorialHiddenKey(userId));
      if (storedValue === "true") {
        setIsLocallyHidden(true);
      }
    }
  }, [userId]);

  const shouldShowTutorial = useMemo(() => {
    if (isLocallyHidden || isTutorialHidden) return false;
    if (isCompanyUserCreatedByRso) return false;
    return isRsoUser || isCompanyUser;
  }, [isLocallyHidden, isTutorialHidden, isRsoUser, isCompanyUser, isCompanyUserCreatedByRso]);

  const handleHideTutorial = () => {
    if (userId) {
      localStorage.setItem(getTutorialHiddenKey(userId), "true");
      setIsLocallyHidden(true);
    }
  };

  return { shouldShowTutorial, handleHideTutorial };
};
